const ApiConstants = {
    VALIDATION_USERNAME: 'api/patient/2fa_send',//'pcp/verification_code',
    PATIENT_EXIST_CHECK: 'api/pcp/patientexistsemailphone',
    VERIFY_CODE: 'api/patient/2fa_verify',
    VALIDATE_PATIENT_EMAIL_PHONE: 'api/patient/validate_email_phone',
    REGISTER_USER_V2: 'api/patient/register',
    PATIENT_DETAILS: 'api/fhir/resource/Patient',
    VALID_CLIENT_URL: 'connect/validClientUrl',
    //get children
    GET_CHILDREN: '/patient/getchildren',
    ADD_CHILDREN: '/patient/addchild',
    ADD_FAMILY_MEMBER: '/patient/addfamilymember',
    ADD_USER_DETAILS: 'api/patient_details',
    CHECK_USER_DETAILS_SIGNED: 'api/patient_details/validate',
    GET_DOC_FROM_ALIAS: 'api/pcp/getDocFromAlias',
    GET_OPEN_TOK_ROOM_KEYS: 'api/pcp/getOpentokRoomKeys',
    ADD_USER_TO_WAITING: 'api/pcp/addUserToWaiting',
    NOTIFY_PROVIDER: 'v1/connect/notify',
    CHECK_ROOM_STATUS: 'api/pcp/checkstatusinwatingroom',
    UPDATE_ROOM_STATUS: 'api/pcp/updatestatusByPatientId',
    GENERATE_CALL_ID_BY_PATIENT: 'api/pcp/generateCallIdByPatientId',
    INVALIDATE: 'v1/tokens/invalidate',
    DISCONNECT_REASON: 'api/pcp/updatetcalldisconnectreason',
    // pVerify
  GET_ALL_PAYERS: 'api/pverify/get_all_payers',
  GET_CO_PAYER_LIST: '/patient-insurance/get-copay-amount/',
  ELIGIBILITY_SUMMARY: 'api/pverify/eligibility_summary',
  MEDICATION_SEARCH: '/doctor/medicationquicksearch',
  ALLERGY_SEARCH: '/patient/allergysearch',
  UPLOAD_MEDICATIONS: 'api/pcp/updatedataBycallId',
  GET_PLAN_COST: 'api/plan_cost?service_type=medical',
  CALL_END_BY_PATIENT: 'api/pcp/callendbypatient',
  PROVIDER_SETTINGS: 'connect/providersettings',
}
export default ApiConstants;